export function getRouteFromNotificationData(data = {}) {
  const roomId = data?.roomId || data?.consultation?.roomId;
  const type = `${data?.type || ''}`.toLowerCase();

  if (roomId && type.startsWith('consultation_')) {
    return `/consultation?room=${encodeURIComponent(roomId)}`;
  }

  if (roomId) {
    return `/call/${encodeURIComponent(roomId)}`;
  }

  if (data?.orderId) {
    return '/orders';
  }

  return '/notification';
}

export function getRouteFromAppUrl(url) {
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    let routePath = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;

    // For custom schemes (e.g. qureo://notification), host carries the route segment.
    if ((!routePath || routePath === '/' || routePath === '//') && parsedUrl.host) {
      routePath = `/${parsedUrl.host}${parsedUrl.search}${parsedUrl.hash}`;
    }

    if (routePath.startsWith('/app/')) {
      routePath = routePath.slice(4) || '/';
    }

    return routePath || null;
  } catch (err) {
    return null;
  }
}
